<template>
  <div class="mt-4">
    <ToogleFilterBox classString="mx-4 px-0" title="Filtrar" :isFilter="true" @filter="filter" @resetFilter="resetFilter">
        <div class="row m-0 w-100 mb-2">
          <b-form-group id="input-group-2" label="CNPJ:" label-for="cnpj" class="col-lg-6 col-12 px-1">
              <b-form-input id="cnpj" v-model="form.cnpj" placeholder="xx.xxx.xxx/xxxx-xx"
                v-mask="['##.###.###/####-##']" />
          </b-form-group>
          <b-form-group id="input-group-2" label="Razão Social / Nome Fantasia:" label-for="razao-social" class="col-lg-6 col-12 px-1">
            <b-form-input id="name" v-model="form.name" placeholder="digite aqui" trim />
          </b-form-group>
        </div>      
      </ToogleFilterBox>
  </div>
</template>

<script>
import { mask, tokens } from 'vue-the-mask'
import Validations from '@/util/Validations'
import ToogleFilterBox from "@/components/commons/ToogleFilterBox.vue";

export default {
    name: "ConsultarEmpresaFiltro",
    components: {
        ToogleFilterBox,
    },    
    directives: {mask, tokens},
    data() {
      return {
        form : {
            cnpj : null,
            name : null,
        },
      }
	},
   methods: {
      filter() {
        if( Validations.isEmpty(this.form) ) {
          this.$emit("filter-empresa", {} )    
        }
        else {
            let form = {
                ...this.form,
                cnpj: this.form.cnpj && this.form.cnpj.replaceAll("-","").replaceAll(".","").replaceAll("/","") || null,
                name: this.form.name && this.form.name.toUpperCase() || null
            }

          this.$emit("filter-empresa", form)
        }           
      },
      resetFilter(){
          for (let key in this.form)
          {
              this.form[key] = null
          }
      },
    }
}
</script>
<style scoped>
.consultar-empresa-filtro {
	justify-content: space-between;
  color: #707070;
	font-size: 18px;
	text-align: left;
}
</style>